import React, { useState } from 'react';

import { Maximize, Minus, Plus, RotateCcw, RotateCw } from 'lucide-react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

import { Button } from './ui/button.jsx';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip.jsx';

const ImageInspector = ({ src, alt = 'img' }) => {
  const [rotation, setRotation] = useState(0);

  const rotateLeft = () => setRotation((prev) => (prev - 90) % 360);
  const rotateRight = () => setRotation((prev) => (prev + 90) % 360);

  return (
    <div className="flex flex-col gap-4">
      <div className="relative flex min-h-[500px] w-full items-center justify-center overflow-hidden rounded-lg border bg-zinc-50 dark:bg-zinc-950">
        <TransformWrapper
          initialScale={1}
          minScale={0.1}
          maxScale={10}
          centerOnInit
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              {/* Floating Controls */}
              <div className="absolute left-1/2 top-4 z-10 flex -translate-x-1/2 items-center gap-1 rounded-full border bg-background/80 p-1 shadow-lg backdrop-blur-md">
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-9 w-9 rounded-full"
                        onClick={() => zoomIn()}
                      >
                        <Plus className="h-5 w-5" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Zoom In</TooltipContent>
                  </Tooltip>

                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-9 w-9 rounded-full"
                        onClick={() => zoomOut()}
                      >
                        <Minus className="h-5 w-5" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Zoom Out</TooltipContent>
                  </Tooltip>

                  <div className="mx-1 h-6 w-px bg-border" />

                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-9 w-9 rounded-full"
                        onClick={rotateLeft}
                      >
                        <RotateCcw className="h-5 w-5" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Rodar Esquerda</TooltipContent>
                  </Tooltip>

                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-9 w-9 rounded-full"
                        onClick={rotateRight}
                      >
                        <RotateCw className="h-5 w-5" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Rodar Direita</TooltipContent>
                  </Tooltip>

                  <div className="mx-1 h-6 w-px bg-border" />

                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-9 w-9 rounded-full"
                        onClick={() => {
                          resetTransform();
                          setRotation(0);
                        }}
                      >
                        <Maximize className="h-5 w-5" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Resetar</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>

              <TransformComponent
                wrapperStyle={{
                  width: '100%',
                  height: '100%',
                  cursor: 'move',
                }}
                contentStyle={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    transform: `rotate(${rotation}deg)`,
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={src}
                    alt={alt}
                    className="h-auto max-w-full shadow-sm"
                  />
                </div>
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </div>
      <div className="flex justify-center text-xs text-zinc-500">
        Dica: Utilize o scroll do rato para fazer zoom e arraste para mover a
        imagem.
      </div>
    </div>
  );
};

export default ImageInspector;
